import React from "react";
import { FiGlobe, FiUploadCloud, FiCpu } from "react-icons/fi";

const ImageSourceSelector = ({
  selectedSource,
  setSelectedSource,
  disabled,
  allowNoImage,
  setAllowNoImage,
  isPremiumLocked = false,
}) => {
  const sources = [
    {
      id: "internet",
      label: "Internet",
      icon: <FiGlobe className="mr-2" />,
      description: "Tìm kiếm ảnh từ internet phù hợp với nội dung bài viết",
    },
    {
      id: "ai",
      label: "AI tạo ảnh",
      icon: <FiCpu className="mr-2" />,
      description: "Tạo ảnh bằng AI dựa trên nội dung bài viết",
      premiumOnly: true,
    },
    {
      id: "upload",
      label: "Thiết bị",
      icon: <FiUploadCloud className="mr-2" />,
      description: "Tải lên ảnh từ thiết bị của bạn",
    },
  ];

  const handleSourceSelect = (sourceId) => {
    if (disabled) return;
    setSelectedSource(sourceId);
  };

  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-2">
        <label className="block text-gray-700 font-medium">
          Chọn nguồn ảnh
        </label>
        <div className="flex items-center">
          <label className="text-gray-700 mr-2 text-sm">Không dùng ảnh</label>
          <div className="relative inline-block w-12 align-middle select-none">
            <input
              type="checkbox"
              name="allowNoImage"
              id="allowNoImage"
              checked={allowNoImage}
              onChange={(e) => setAllowNoImage(e.target.checked)}
              className="hidden"
            />
            <label
              htmlFor="allowNoImage"
              className={`block overflow-hidden h-6 rounded-full cursor-pointer transition-colors duration-200 ease-in-out
                ${allowNoImage ? "bg-blue-600" : "bg-gray-300"}`}
            >
              <span
                className={`block h-6 w-6 rounded-full shadow transform transition-transform duration-200 ease-in-out
                  ${
                    allowNoImage
                      ? "translate-x-6 bg-white"
                      : "translate-x-0 bg-white"
                  }`}
              />
            </label>
          </div>
        </div>
      </div>
      <div
        className={`grid grid-cols-1 md:grid-cols-3 gap-3 ${
          allowNoImage ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        {sources.map((source) => {
          const isLocked = source.premiumOnly && isPremiumLocked;
          return (
            <div
              key={source.id}
              onClick={() => handleSourceSelect(source.id)}
              className={`border rounded-md p-3 cursor-pointer flex flex-col transition-colors ${
                selectedSource === source.id
                  ? "border-blue-500 bg-blue-50"
                  : "border-gray-300 hover:border-blue-300 hover:bg-blue-50"
              } ${disabled ? "opacity-50 pointer-events-none" : ""} ${
                isLocked ? "opacity-75" : ""
              }`}
            >
              <div className="flex items-center mb-2">
                <div
                  className={`flex items-center justify-center ${
                    selectedSource === source.id
                      ? "text-blue-600"
                      : "text-gray-600"
                  }`}
                >
                  {source.icon}
                  <span className="font-medium">{source.label}</span>
                </div>
                <div className="ml-auto flex items-center gap-1.5">
                  {isLocked && (
                    <span className="inline-flex items-center gap-1 px-1.5 py-0.5 bg-amber-100 text-amber-700 text-[10px] font-semibold rounded-full">
                      🔒 Cao Cấp
                    </span>
                  )}
                  <input
                    type="radio"
                    name="imageSource"
                    checked={selectedSource === source.id}
                    onChange={() => handleSourceSelect(source.id)}
                    className="text-blue-600 focus:ring-blue-500 cursor-pointer"
                    disabled={disabled}
                  />
                </div>
              </div>
              <p className="text-sm text-gray-600">{source.description}</p>
            </div>
          );
        })}
      </div>
      {isPremiumLocked && !allowNoImage && (
        <div className="mt-2 flex items-center gap-2 p-2 bg-amber-50 border border-amber-200 rounded-lg">
          <span className="text-amber-600 text-sm">⬆️</span>
          <p className="text-sm text-amber-700">
            Nâng cấp lên gói <strong>Cao Cấp</strong> để sử dụng tính năng tạo ảnh bằng AI.
          </p>
        </div>
      )}
    </div>
  );
};

export default ImageSourceSelector;
